import React from 'react'
import TermBreadCrumb from './TermBreadCrumb';
import TermsConditions from './TermsConditions';

function TermsConditionsPage() {
    return ( 
        <>
        <TermBreadCrumb />
        <TermsConditions />
        </>
     );
}

export default TermsConditionsPage;